'use client';

import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';

export interface ReportFaqItem {
  q: string;
  a: string;
}

interface ReportFaqAccordionProps {
  faqs: ReportFaqItem[];
}

export function ReportFaqAccordion({ faqs }: ReportFaqAccordionProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const toggle = (idx: number) => {
    setOpenIndex(openIndex === idx ? null : idx);
  };

  return (
    <div className="space-y-3" data-testid="report-faq-accordion">
      {faqs.map((faq, idx) => {
        const isOpen = openIndex === idx;
        return (
          <div
            key={idx}
            className="rounded-2xl bg-gradient-to-br from-white/10 to-white/[0.02] border border-white/18 shadow-[inset_0_1px_0_rgba(255,255,255,0.2)] backdrop-blur-xl overflow-hidden transition-all duration-200"
          >
            <button
              type="button"
              onClick={() => toggle(idx)}
              className="w-full text-left px-5 sm:px-6 py-4 sm:py-5 flex items-center justify-between gap-4 font-['Lexend'] text-sm sm:text-base font-medium text-white hover:text-[#5ab4ff] transition-colors cursor-pointer"
              aria-expanded={isOpen}
              data-testid={`faq-toggle-${idx}`}
            >
              <span>{faq.q}</span>
              <span className="w-7 h-7 rounded-full bg-white/10 grid place-items-center text-white shrink-0 transition-transform duration-200">
                <ChevronDown className={`w-4 h-4 transition-transform duration-200 ${isOpen ? 'rotate-180 text-[#5ab4ff]' : 'text-white/70'}`} />
              </span>
            </button>
            {isOpen && (
              <div
                className="px-5 sm:px-6 pb-5 text-xs sm:text-sm text-[#dcecff]/85 leading-relaxed font-['Outfit'] border-t border-white/10 pt-4"
                data-testid={`faq-content-${idx}`}
              >
                {faq.a}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
